import React, {useEffect} from 'react';
import DocumentHeader from "./DocumentsComponents/DocumentHeader";
import DocumentMesure from "./DocumentsComponents/DocumentMesure";
import DocumentIntro from "./DocumentsComponents/DocumentIntro";
import DocumentSurvey from "./DocumentsComponents/DocumentSurvey";
import DocumentReview from "./DocumentsComponents/DocumentReview";
import DocumentImg from "./DocumentsComponents/DocumentImg";
import DocumentPrescription from "./DocumentsComponents/DocumentPrescription";
import DocumentConclusion from "./DocumentsComponents/DocumentConclusion";
import DocumentSignature from "./DocumentsComponents/DocumentSignature";

const GeneralReport = ({
                           prescription,
                           patient,
                           appointment,
                           orthoptist,
                           mesures,
                           ophtalmologist,
                           conclusion,
                           islocked,
                           message,
                           user_type
                       }) => {

    useEffect(() => {
        window.status = "ready";
    }, []);

    return <div style={{display: "flex", justifyContent: "center"}}>
        <div className="card page" style={{width: "210mm", height: "296mm", margin: 20}}>
            <div className="pdf-document" style={{display: "flex", flexDirection: "column"}}>
                <DocumentHeader orthoptist={orthoptist} ophtalmologist={ophtalmologist} patient={patient}
                                appointment={appointment}/>
                <DocumentIntro orthoptist={orthoptist} appointment={appointment} patient={patient}/>
                <DocumentSurvey appointment={appointment} patient={patient}/>
                <DocumentReview appointment={appointment} patient={patient}/>
                <DocumentMesure mesures={mesures}/>
                <div className="prevent-break">
                    <DocumentImg appointment={appointment}/>
                    <DocumentConclusion prescription={prescription} conclusion={conclusion} appointment={appointment}
                                        message={message} islocked={islocked} user_type={user_type} analyst={ophtalmologist}/>
                    <DocumentSignature prescription={prescription} ophtalmologist={ophtalmologist}/>
                </div>
            </div>
        </div>
    </div>
}
export default GeneralReport;